import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "./App.css";
import "../assets/style.css";
import "../assets/stencil_management.css";
import "../assets/event_management.css";
import AdminLogin from "../admin/screens/Login.jsx";
import EventManagement from "../admin/screens/EventManagement.jsx";
import StencilSelection from "../admin/screens/StencilSelection.jsx";
import StencilManagement from "../admin/screens/StencilManagement.jsx";
import Landing from "../volunteer/screens/Landing.jsx";
import EventLogin from "../volunteer/screens/EventLogin.jsx";
import VolunteerTimer from "../volunteer/screens/VolunteerTimer.jsx";
import VolunteerComplete from "../volunteer/screens/VolunteerComplete.jsx";
import VolunteerConfirm from "../volunteer/screens/VolunteerConfirm.jsx";

// Only allow route access if user is authenticated (as an admin)
const AdminProtectedRoute = ({ isAdminAuthenticated, children }) => {
  if (!isAdminAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

// Only allow route access if user is authenticated (as an admin)
const VolunteerProtectedRoute = ({ isVolunteerAuthenticated, children }) => {
  if (!isVolunteerAuthenticated) {
    return <Navigate to="/volunteer/landing/" replace />;
  }
  return children;
};

function App() {
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(false);
  const [isVolunteerAuthenticated, setIsVolunteerAuthenticated] =
    useState(false);

  // volunteer information that needs to pass through each page
  const [stencilData, setStencilData] = useState(null);
  const [volunteerName, setVolunteerName] = useState("");
  const [time, setTime] = useState(0);

  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<Navigate to="volunteer" replace />} />
        {/* Admin routes */}
        <Route
          path="admin/*"
          element={
            <Routes>
              <Route
                index
                element={<Navigate to="stencil-selection" replace />}
              />
              <Route
                path="login"
                element={
                  <AdminLogin
                    isAdminAuthenticated={isAdminAuthenticated}
                    setIsAdminAuthenticated={setIsAdminAuthenticated}
                  />
                }
              />
              <Route
                path="event-management"
                element={
                  <AdminProtectedRoute
                    isAdminAuthenticated={isAdminAuthenticated}
                  >
                    <EventManagement
                      isAdminAuthenticated={isAdminAuthenticated}
                      setIsAdminAuthenticated={setIsAdminAuthenticated}
                    />
                  </AdminProtectedRoute>
                }
              />
              <Route
                path="stencil-selection"
                element={
                  <AdminProtectedRoute
                    isAdminAuthenticated={isAdminAuthenticated}
                  >
                    <StencilSelection
                      isAdminAuthenticated={isAdminAuthenticated}
                      setIsAdminAuthenticated={setIsAdminAuthenticated}
                    />
                  </AdminProtectedRoute>
                }
              />
              <Route
                path="stencil-management"
                element={
                  <AdminProtectedRoute
                    isAdminAuthenticated={isAdminAuthenticated}
                  >
                    <StencilManagement
                      isAdminAuthenticated={isAdminAuthenticated}
                      setIsAdminAuthenticated={setIsAdminAuthenticated}
                    />
                  </AdminProtectedRoute>
                }
              />
            </Routes>
          }
        />

        {/* Volunteer routes */}
        <Route
          path="volunteer/*"
          element={
            <Routes>
              <Route index element={<Navigate to="landing" replace />} />
              <Route
                path="landing"
                element={
                  <EventLogin
                    isVolunteerAuthenticated={isVolunteerAuthenticated}
                    setIsVolunteerAuthenticated={setIsVolunteerAuthenticated}
                  />
                }
              />

              <Route
                path="stencil-info"
                element={
                  <VolunteerProtectedRoute
                    isVolunteerAuthenticated={isVolunteerAuthenticated}
                  >
                    <Landing
                      isVolunteerAuthenticated={isVolunteerAuthenticated}
                      setIsVolunteerAuthenticated={setIsVolunteerAuthenticated}
                      setStencilData={setStencilData}
                      setVolunteerName={setVolunteerName}
                      volunteerName={volunteerName}
                    />
                  </VolunteerProtectedRoute>
                }
              />

              <Route
                path="confirm"
                element={
                  <VolunteerProtectedRoute
                    isVolunteerAuthenticated={isVolunteerAuthenticated}
                  >
                    <VolunteerConfirm
                      isVolunteerAuthenticated={isVolunteerAuthenticated}
                      setIsVolunteerAuthenticated={setIsVolunteerAuthenticated}
                      setStencilData={setStencilData}
                      stencilData={stencilData}
                      volunteerName={volunteerName}
                    />
                  </VolunteerProtectedRoute>
                }
              />

              <Route
                path="timer"
                element={
                  <VolunteerProtectedRoute
                    isVolunteerAuthenticated={isVolunteerAuthenticated}
                  >
                    <VolunteerTimer
                      isVolunteerAuthenticated={isVolunteerAuthenticated}
                      setIsVolunteerAuthenticated={setIsVolunteerAuthenticated}
                      volunteerName={volunteerName}
                      stencilData={stencilData}
                      setTime={setTime}
                      time={time}
                    />
                  </VolunteerProtectedRoute>
                }
              />

              <Route
                path="complete"
                element={
                  <VolunteerProtectedRoute
                    isVolunteerAuthenticated={isVolunteerAuthenticated}
                  >
                    <VolunteerComplete
                      isVolunteerAuthenticated={isVolunteerAuthenticated}
                      setIsVolunteerAuthenticated={setIsVolunteerAuthenticated}
                      setStencilData={setStencilData}
                      stencilData={stencilData}
                      setTime={setTime}
                      time={time}
                    />
                  </VolunteerProtectedRoute>
                }
              />
            </Routes>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
